import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import { apiFetch } from "api/Api";
import { FaPlus, FaEdit, FaTrash, FaShareAlt, FaSave, FaTimes, FaInbox } from "react-icons/fa";
import "assets/theme/admin_list.css";

const SourceList = () => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const fetchSources = async () => {
    try {
      const response = await apiFetch("super_admin/list_source");
      setSources(response.sources || []);
    } catch (error) {
      console.error("Error fetching sources:", error);
      alert("Failed to load sources");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSources();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this source?")) return;

    try {
      await apiFetch(`super_admin/delete_source/${id}`, {
        method: "DELETE",
      });
      fetchSources();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleEditClick = (source) => {
    setEditId(source.source_id);
    setEditName(source.source_name);
  };

  const handleUpdate = async (id) => {
    if (!editName.trim()) {
      alert("Source name cannot be empty");
      return;
    }

    try {
      await apiFetch(`super_admin/edit_source/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ source_name: editName }),
      });

      setEditId(null);
      fetchSources();
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaShareAlt />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  Source Management / स्त्रोत व्यवस्थापन
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage complaint and inquiry intake channels & sources
                </p>
              </div>
            </div>

            <Link to="/add_source" className="btn btn-admin-add">
              <FaPlus /> <span>Add Source / स्त्रोत जोडा</span>
            </Link>
          </div>
        </div>

        {/* List Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : sources.length === 0 ? (
              <div className="text-center py-5">
                <FaInbox className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No sources found</h6>
                <p className="text-muted small mb-0">No intake sources have been configured yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>Source Name / स्त्रोताचे नाव</th>
                      <th className="text-center" style={{ width: "160px" }}>Actions / क्रिया</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sources.map((source, index) => (
                      <tr key={source.source_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>
                        <td>
                          {editId === source.source_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm border-warning fw-semibold shadow-sm"
                              value={editName}
                              onChange={(e) => setEditName(e.target.value)}
                              autoFocus
                            />
                          ) : (
                            <span className="fw-bold text-dark">{source.source_name}</span>
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            {editId === source.source_id ? (
                              <>
                                <button
                                  className="btn btn-sm btn-success px-3 fw-semibold text-white d-flex align-items-center gap-1"
                                  onClick={() => handleUpdate(source.source_id)}
                                >
                                  <FaSave /> <span>Save</span>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary px-2 d-flex align-items-center gap-1"
                                  onClick={() => setEditId(null)}
                                >
                                  <FaTimes />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn-action-icon edit"
                                  title="Edit Source"
                                  onClick={() => handleEditClick(source)}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="btn-action-icon delete"
                                  title="Delete Source"
                                  onClick={() => handleDelete(source.source_id)}
                                >
                                  <FaTrash />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SourceList;
